module.exports = __webpack_public_path__ + "d8994dd252eb1758c0aada1dc6435d3e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/pink-diamond-right.png
// module id = 2707
// module chunks = 0